<template>
  <div class="ped-card" :class="isMale ? 'male-card' : 'female-card'">
    <div class="ped-header" :class="isMale ? 'bg-male' : 'bg-female'">
      <span>
        {{ label }}
      </span>
      <a v-if="node?.id" class="preview-btn" @click="goToPreview">
        <i class="material-symbols-rounded">table_eye
        </i>
      </a>
    </div>
    <div class="ped-body">
      <!-- Studbook -->
      <div class="ped-row">
        <span class="ped-label">
          Stamboeknummer:
        </span>
        <span class="ped-value ped-green">
          {{ node?.studbooknumber || '—' }}
        </span>
      </div>
      <!-- Tag -->
      <div class="ped-row">
        <span class="ped-label">
          Levensnummer:
        </span>
        <span class="ped-value">
          {{ node?.tagnumber || '—' }}
          |
          {{ node?.countrycode || '—' }}
        </span>
      </div>
      <!-- Name -->
      <div class="ped-row">
        <span class="ped-label">
          Naam:
        </span>
        <span class="ped-value">
          {{ node?.name || '—' }}
        </span>
      </div>
      <!-- Birth -->
      <div class="ped-row">
        <span class="ped-label">
          Geboortedatum:
        </span>
        <span class="ped-value">
          {{ node?.birthdate || '—' }}
        </span>
      </div>
      <!-- Genotype -->
      <div class="ped-row">
        <span class="ped-label">
          Genotype:
        </span>
        <span class="ped-value">
          {{ node?.genotype || '—' }}
        </span>
      </div>

      <!-- Litter -->
      <div class="ped-row">
        <span class="ped-label">
          Worpgrootte:
        </span>

        <span class="ped-value">
          {{ node?.siblings || '—' }}
          |
          Worpen:
          {{ node?.nobirths || '—' }}
          |
          Lammeren:
          {{ node?.nolambs || '—' }}
        </span>

      </div>

      <!-- =========================================
           SCORE TABLE
      ========================================== -->

      <table class="ped-table">

        <tbody>

          <tr>
            <th>HF</th>
            <th>HO</th>
            <th>NE</th>
            <th>VH</th>
            <th>MH</th>
          </tr>

          <tr>
            <td>{{ node?.keurPunten?.HF || '–' }}</td>
            <td>{{ node?.keurPunten?.HO || '–' }}</td>
            <td>{{ node?.keurPunten?.NE || '–' }}</td>
            <td>{{ node?.keurPunten?.VH || '–' }}</td>
            <td>{{ node?.keurPunten?.MH || '–' }}</td>
          </tr>

          <tr>
            <th>AH</th>
            <th>BW</th>
            <th>ST</th>
            <th>HV</th>
            <th>AV</th>
          </tr>

          <tr>
            <td>{{ node?.keurPunten?.AH || '–' }}</td>
            <td>{{ node?.keurPunten?.BW || '–' }}</td>
            <td>{{ node?.keurPunten?.ST || '–' }}</td>
            <td>{{ node?.keurPunten?.HV || '–' }}</td>
            <td>{{ node?.keurPunten?.AV || '–' }}</td>
          </tr>

        </tbody>

      </table>

    </div>

  </div>

</template>

<script>

import { useRouter } from 'vue-router'

export default {

  name: 'PedigreeNode',

  props: {

    node: {
      type: Object,
      default: null
    },

    label: {
      type: String,
      default: ''
    }

  },

  setup(props){

    const router = useRouter()

    const goToPreview = () => {

      if(props.node?.id){

        router.push({
          name: 'Preview Animal',
          params: {
            id: props.node.id
          },
          query: {
            call: 'pedigree'
          }
        })

      }

    }

    return {
      goToPreview
    }

  },

  computed: {

    isMale(){

      return this.node?.gender === 'M'

    }

  }

}

</script>

<style scoped>

.ped-card{
    width:320px;
    border-radius:5px;
    overflow:hidden;
    background:#ffffff;
    box-shadow:0 4px 16px rgba(0,0,0,0.12);
    transition:all .2s ease;
}

.ped-card:hover{
    transform:translateY(-2px);
    box-shadow:0 6px 22px rgba(0,0,0,0.16);
}

.ped-header{
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding:6px 10px;
    color:#ffffff;
    font-size:14px;
    font-weight:600;
}

.bg-male{
    background:#4e61d3;
}

.bg-female{
    background:#d63384;
}

.preview-btn{
    cursor:pointer;
    display:flex;
    align-items:center;
    justify-content:center;
    color:#ffffff;
    text-decoration:none;
}

.preview-btn i{
    font-size:20px;
}

.ped-body{
    padding:5px;
}

.ped-row{
    margin-bottom:2px;
    line-height:1.0;
}

.ped-label{
    font-weight:500;
    color:#667085;
    font-size:12px;
}

.ped-value{
    color:#667085;
    font-size:12px;
}

.ped-green{
    color:#0f8d09;
    font-weight:500;
}

.ped-table{
    width:100%;
    border-collapse:collapse;
    margin-top:12px;
    text-align:center;
}

.ped-table th{
    background:#f1f3f5;    
    border:1px solid #e5e7eb;
    font-size:10px;
    font-weight:500;
}

.ped-table td{
    border:1px solid #e5e7eb;
    font-size:10px;
    color:#6b7280;
}

@media (max-width:768px){
    .ped-card{
        width:100%;
    }
}

</style>